import { useEffect, useState } from "react";
import { Icon } from "./Icon";

/**
 * Floating "back to top" button. Appears after the user scrolls down, and
 * smoothly returns to the top (instant when reduced motion is preferred).
 * Sits above the sticky mobile call/quote bar on small screens.
 */
export function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, left: 0, behavior: reduce ? "auto" : "smooth" });
  };

  return (
    <button
      type="button"
      className={`backtotop ${visible ? "is-visible" : ""}`}
      onClick={toTop}
      aria-label="Back to top"
      tabIndex={visible ? 0 : -1}
    >
      <Icon name="arrow-up" size={22} />

      <style>{`
        .backtotop {
          position: fixed;
          right: var(--space-5);
          bottom: var(--space-5);
          z-index: 95;
          width: 50px;
          height: 50px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: var(--navy);
          color: var(--white);
          border: 2px solid var(--navy);
          cursor: pointer;
          clip-path: polygon(12px 0, 100% 0, 100% calc(100% - 12px), calc(100% - 12px) 100%, 0 100%, 0 12px);
          opacity: 0;
          transform: translateY(14px);
          pointer-events: none;
          transition: opacity var(--duration-base) var(--ease-out),
            transform var(--duration-base) var(--ease-out),
            background var(--duration-fast) var(--ease-standard);
          box-shadow: var(--shadow-lg);
        }
        .backtotop.is-visible {
          opacity: 1;
          transform: translateY(0);
          pointer-events: auto;
        }
        .backtotop:hover {
          background: var(--orange);
          border-color: var(--orange);
        }
        @media (max-width: 899px) {
          .backtotop { bottom: 96px; right: var(--space-4); }
        }
      `}</style>
    </button>
  );
}
